<span>{{ data.message }}</span>
<a class="snack-bar-button" [routerLink]="data.link" (click)="snackBarRef.dismiss()" [attr.test-id]="data.testId" mat-button>{{ data.linkName }}</a>